/* Welcome to Aqa*/
/* Version: 1 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import IconButton from "@material-ui/core/IconButton";
import {ReactComponent as NewSourceIcon} from "../../images/aqa-icons/AQA-Delete.svg";
import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AqaComponent from "../shared/aqacomponent/AqaComponent";
import {ReactComponent as FolderIcon} from "../../images/aqa-icons/Usercol.svg";
import HtmlTooltip from "@material-ui/core/Tooltip";
import {ReactComponent as CloseIcon} from "../../images/aqa-icons/AQA-Exclude.svg";
//import {ReactComponent as SourceIcon} from "../../images/aqa-icons/Sourcecol.svg";


const styles = theme => ({
    welcomelabel: {
        fontSize: 18,
        marginTop: 18,
        marginBottom: 0,
        marginLeft: 20,
        marginRight: 20,
        color: "white"
    },
    getstartedlabel: {
        fontSize: 14,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: 20,
        marginRight: 20,
        color: "#1e2b56"
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: 0,
        width: "200px",
        minWidth: 100,
    },
    formControlLabel: {
        marginTop: 0,
        fontSize: 14,
    },
    textField: {
        fontFamily: 'Open Sans, sans-serif',
        fontSize: 16,
    },
    reportTitle: {
        fontSize: 15,
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: "bold",
        marginBottom: 4,
        marginLeft: 8,
        color: "#1e2b56"
    },
    reportInstruction: {
        fontSize: 13,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
        marginLeft: 8,
        width: "95%",
        height: 50,
        color: "#1e2b56"
    },
    demo: {

    },
    reportBody: {
        fontSize: 16,
        fontFamily: 'Open Sans, sans-serif',
        marginBottom: 4,
        color: "#1e2b56"
    }
});

class AqaPMDelete extends AqaComponent {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            notfound: false,
            isLoaded: true,
            dense: false,
            openMessage: false,
            openDeleteMessage: false,
            openProgress:false,
            secondary: true,
            redirect: false,
            currentFolder:"allsources",
            periodicities: [],
            periodicity: "daily",
            SourceName: "",
            SourceDescription: null,
            errorMessage: "",
            file: null,
            folders:[],
            selectedSources:[],
            selectedFolders:[],
            disableAction:false,

        };
        this.handleDeletePMsClosePopup=this.handleDeletePMsClosePopup.bind(this);
        this.handlePMDeleteClick=this.handlePMDeleteClick.bind(this);
        this.handleDeletePM=this.handleDeletePM.bind(this);


    }


    handleClosePopup(e) {
        e.preventDefault();
// onsole.log(this.props.dataFromRoot);
        this.props.dataFromRoot.handlePMSelectionReset();
        this.setState({ errorMessage:"",openMessage: false,openDeleteMessage: false,SourceName:"",SourceDescription:"",periodicity:"daily" });
    }

    handlePMDeleteClick(e) {
        e.preventDefault();
        this.setState({ openDeleteMessage: true });
    }


    handleDeletePM(pm,last){
        if(pm!== null) {
            AqaComponent.backend.deletePaymentMethod
            (
                pm.id,
                (error, paymentMethodList, response) =>
                {
                    //let removePleaseWaitMessage = false;
                    if (error)
                    {
                        this.reportError("Sorry an error occurred, please try again later", error);
                    }
                    else
                    {
                        // It succeeded, we display the new payment methods.
                        this.setState({paymentMethodList, showWaitForPaymentMethodChange: false});
                        this.props.dataFromRoot.handlePMSelectionReset();
                    }
                }
            );
        }
        if(pm === null && last === true){
            setTimeout(()=>{this.props.dataFromRoot.handlePMSelectionReset();
            },1000);

        }

    }


    handleDeletePMsClosePopup(e){
        var selectedPMs=this.props.dataFromRoot.state.selectedPMs;
        if(selectedPMs.length>0){
            for(var l=0;l<selectedPMs.length;l++) {
                var last=false;
                var selectedPM = selectedPMs[l];
                if(l===selectedPMs.length-1){
                    last=true;
                }
                if(selectedPM.default !== true ) {
                    this.handleDeletePM(selectedPM, last);
                }
                else{
                    this.handleDeletePM(null, last);
                }
            }
        }
    }


    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        var selectedPMs=nextProps.dataFromRoot.state.selectedPMs;
        var disabled=false;
        if(selectedPMs.length>0){
            for(var l=0;l<selectedPMs.length;l++) {
                var selectedPM = selectedPMs[l];
                if(selectedPM.default === true) {
                    disabled=true;
                }
            }
        }
        this.setState({disableAction:disabled});
    }


    componentDidMount(){
        //this.setState({selectedSources:this.props.dataFromParent.state.selectedSources});
        var selectedPMs=this.props.dataFromRoot.state.selectedPMs;
        var disabled=false;
        if(selectedPMs.length>0){
            for(var l=0;l<selectedPMs.length;l++) {
                var selectedPM = selectedPMs[l];
                if(selectedPM.default === true) {
                    disabled=true;
                }
            }
        }
        this.setState({disableAction:disabled});
    }
    render() {
        //const { classes } = this.props;
        const { error, isLoaded, redirect, notfound,errorMessage,disableAction } = this.state;
        if(redirect){
            //return <Redirect to="/login" push={true} />
        }
        else if (notfound && error) {
            return (
                <Grid container spacing={0} direction="row" justify="space-between" alignItems="center"
                      style={{padding: 0, marginTop: 0}}>

                    <Grid item xs={10} sm={7} lg={11} xl={11}>
                        <Typography variant="title" color="inherit" align="left"
                                    style={{ fontSize: '1.5rem',
                                        padding: '0.1em 0.5em',
                                        fontFamily: 'Open Sans, sans-serif'}}>
                            Nothing to display
                        </Typography>
                    </Grid>

                    <Grid item xs={2} sm={1} lg={1} xl={1}>

                    </Grid>
                </Grid>
            );
        }
        else if (error && !notfound) {
            return <div>
                <Typography variant="title" color="inherit" align="left"
                            style={{ fontSize: '1.5rem',
                                padding: '3.1em 0.5em',
                                fontFamily: 'Open Sans, sans-serif'}}>
                    Error: {error.message}
                </Typography>


            </div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            return (
                <div>
                    <Grid container spacing={0} direction="row" justify="space-between" alignItems="center"
                          style={{padding: 0, marginTop: 0}}>

                        <Grid item xs={12} sm={12} lg={12} xl={12}>
                            <Typography variant="inherit" color="inherit" style={{textAlign:"left",fontSize:"0.8rem",width:"100%",paddingTop:"5px"}}>
                                {(disableAction===false)?(
                                    <HtmlTooltip enterDelay={500} title={<React.Fragment>
                                        <div>
                                            <Typography color="inherit" className="aqa-text-action">Click to delete selected payment method(s)</Typography>
                                        </div>
                                    </React.Fragment>} arrow={"true"} placement="bottom-start">
                                        <IconButton className="aqa-button" onClick={this.handlePMDeleteClick.bind(this)} disabled={false} >

                                            <div className="aqa-icon" >
                                                <NewSourceIcon width="32px" />
                                            </div>
                                            <Typography className="aqa-action-header-text" variant="inherit" style={{textAlign:"left",color:"#04A6FC",paddingLeft:"4px",marginTop:"-4px"}}>
                                                DELETE
                                            </Typography>
                                        </IconButton>
                                    </HtmlTooltip>
                                ):(
                                    <HtmlTooltip enterDelay={500} title={<React.Fragment>
                                        <div>
                                            <Typography color="inherit" className="aqa-text-action">Operation not permitted</Typography>
                                        </div>
                                    </React.Fragment>} arrow={"true"} placement="bottom-start">
                                        <div>
                                            <IconButton className="aqa-button" disabled={true} >

                                                <div className="aqa-icon aqa-icon-d-disabled" >
                                                    <NewSourceIcon width="32px" />
                                                </div>
                                                <Typography className="aqa-action-header-text" variant="inherit" style={{textAlign:"left",color:"#dadbdb",paddingLeft:"4px",marginTop:"-4px"}}>
                                                    DELETE
                                                </Typography>
                                            </IconButton>
                                        </div>
                                    </HtmlTooltip>
                                )}

                            </Typography>
                        </Grid>

                    </Grid>

                    <Dialog
                        open={this.state.openDeleteMessage}
                        //onClose={this.handleCloseMessage}
                        aria-labelledby="max-width-dialog-title"
                        maxWidth="lg"
                    >
                        <DialogTitle id="simple-dialog-title" className="aqa-dialog-header" style={{"color":"white !important",padding:"14px 14px 10px"}}>
                            <Typography variant="inherit" color="inherit" style={{textAlign:"left",fontSize:"14px",color:"white",paddingLeft:"4px",fontFamily:"Montserrat",float:"left",width:"96%"}}>
                                Delete Payment Method(s)
                            </Typography>
                            <Typography variant="inherit" color="inherit" style={{textAlign:"left",fontSize:"14px",color:"white",paddingLeft:"0px",fontFamily:"Montserrat",float:"left",width:"3%"}}>
                                <IconButton className="aqa-button" onClick={this.handleClosePopup.bind(this)} style={{padding:"0px"}} >
                                    <div className="aqa-g-icon" style={{width:"20px"}}>
                                        <CloseIcon width="20px" />
                                    </div>
                                </IconButton>
                            </Typography>
                        </DialogTitle>
                        <DialogContent align="center" style={{padding: 0,minWidth:"500px"}}>
                            <Grid container spacing={0} direction="row" justify="space-between" alignItems="center"
                                  style={{padding: 0, marginTop: 0}}>
                                <Grid item xs={12} sm={12} lg={12} xl={12}>
                                    <Typography variant="inherit" color="inherit" style={{textAlign:"left",fontSize:"0.8rem",color:"#006",padding:"5px"}}>
                                        {(errorMessage !=="")?errorMessage:"."}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} direction="row" justify="space-between" alignItems="center"
                                  style={{padding: 0, marginTop: 0}}>
                                <Grid item xs={12} sm={12} lg={12} xl={12}>
                                    <Typography variant="inherit" color="inherit" style={{textAlign:"left",fontSize:"0.8rem",color:"#006",padding:"5px"}}>
                                        {("Are you sure you want to Delete selected Payment Method(s)")}
                                    </Typography>
                                    <Typography variant="inherit" color="inherit" style={{textAlign:"left",fontSize:"0.8rem",color:"#006",padding:"5px"}}>
                                        {(this.props.dataFromRoot.state.selectedPMs.filter((d)=>{
                                                return d.default !== true
                                            }).map((item,index)=>(
                                                <div key={item.id+"_folder_"+index}>
                                                <span style={{float:"left",width:"32px"}}>
                                            <IconButton className="aqa-button" style={{padding:"4px"}}>
                                                <div className="aqa-folder-list-icon">
                                                    <FolderIcon width={"24px"} />
                                                </div>
                                            </IconButton>
                                                    </span>
                                                    <span style={{float:"left"}}>
                                            <Typography variant="inherit" color="inherit" style={{textAlign:"left",fontSize:"0.8rem",color:"#006",padding:"5px",marginTop:"5px"}}>
                                                **** {item.last4Digits}
                                            </Typography>
                                            </span>
                                                </div>
                                            ))
                                        )}
                                    </Typography>
                                </Grid>


                            </Grid>


                            <Grid container spacing={0} direction="row" justify="space-between" alignItems="flex-start"
                                  style={{padding: 0, marginTop: 10,marginLeft:0, marginBottom: 10,borderTop:"1px solid #ccc",width:"500px"}}>

                                <Grid item xs={1} sm={1} lg={1} xl={1}>
                                    <Button onClick={this.handleClosePopup.bind(this)} variant="contained"
                                            color="primary"
                                            align="left"
                                            className="aqa-action-button"
                                            style={{
                                                marginTop: 8,
                                                marginLeft: 8,
                                                color: '#4cadc4',
                                                backgroundColor: 'white',
                                                border: '1px solid #4cadc4',
                                                fontSize: '0.7rem',
                                                padding: '3px'
                                            }}>
                                        Cancel
                                    </Button>


                                </Grid>

                                <Grid item xs={9} sm={9} lg={9} xl={9}>
                                </Grid>
                                <Grid item xs={2} sm={2} lg={2} xl={2}>
                                    <Button  variant="contained"
                                             onClick={this.handleDeletePMsClosePopup.bind(this)}
                                             color="primary"
                                             align="left"
                                             className="aqa-action-button"
                                             style={{
                                                 marginTop: 8,
                                                 color: '#4cadc4',
                                                 backgroundColor: 'white',
                                                 border: '1px solid #4cadc4',
                                                 fontSize: '0.7rem',
                                                 padding: '3px',
                                             }}>
                                        Delete
                                    </Button>



                                </Grid>

                            </Grid>
                        </DialogContent>
                    </Dialog>
                </div>
            );
        }
    }
}

AqaPMDelete.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AqaPMDelete);
